import { morphism } from 'morphism'
import { formatDate } from 'tfs.front-end-utils/dates'

import seatTradeSchema from '../../schemas/seatTrade'

import SeatTradeModel from '../../models/SeatTrade'

import staticData from '../../config/staticData'
import constants from '../../config/constants'

import callAPI from '../../utils/requests/callAPI'
import { moment } from '../../utils/dates'
import setAuthorizationHeader from '../../utils/requests/setAuthorizationHeader'
import {
  userHasCustomTourOperatorCode,
  userCustomTourOperatoreCode,
} from '../../utils/tourOperators'

import { v1receiveSeatTradeSearchResults } from '../../actions/seatTrade'
import { V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS } from '../../actions/seatTrade/v1requestSeatTradeSearchResults'
import v1throwError from '../../actions/errors/v1throwError'
import v1receiveSearchResults from '../../actions/search/v1receiveSearchResults'

export default store => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS) {
    return
  }

  const dispatch = store.dispatch
  const headers = new Headers(staticData.endpoints.allotments.headers)

  const {
    departureAirportId,
    arrivalAirportId,
    startDate,
    endDate,
  } = action.data
  const { backEndDateFormat, fromFlightIdDateFormat } = constants

  const formattedStartDate = formatDate(
    moment,
    startDate,
    backEndDateFormat,
    fromFlightIdDateFormat
  )
  const formattedEndDate = formatDate(
    moment,
    endDate,
    backEndDateFormat,
    fromFlightIdDateFormat
  )

  const departureDate = `${formattedStartDate}-${formattedEndDate}`
  const route = `${departureAirportId}-${arrivalAirportId}`

  const baseUrl = `${
    staticData.endpoints.allotments.url
  }/seattrade?departureDate=${departureDate}&route=${route}`

  const url = userHasCustomTourOperatorCode()
    ? `${baseUrl}&tourOperatorCode=${userCustomTourOperatoreCode()}`
    : baseUrl

  try {
    await setAuthorizationHeader(headers)
    const data = await callAPI(url, {
      headers,
    })

    if (data.error) throw data.error

    const flights = data.length
      ? data.map(flight => morphism(seatTradeSchema, flight, SeatTradeModel))
      : []

    dispatch(v1receiveSearchResults(action.data))

    dispatch(v1receiveSeatTradeSearchResults(flights))
  } catch (error) {
    dispatch(v1throwError(error))
  }
}
